import React, { useContext } from "react";
import { Link } from 'react-router-dom'
import profileIconSrc from "../../assets/profile-icon.png";
import exitIconSrc from "../../assets/exit-icon.png";
import styled from "styled-components";
import { UserContext } from "../../contexts/UserContext";
import api from "../../services/api";
const ProfileIcon = () => {
    return (
        <img
            className="pr-2"
            src={profileIconSrc}
            alt="Perfil"
            title="Perfil"
        ></img>
    );
};

const ExitIcon = () => {
    return (
        <img className="pr-2" src={exitIconSrc} alt="Sair" title="Sair"></img>
    );
};

const BlueParaprah = styled.p`
    color: #2c3b82;
`;
const GreyParagraph = styled.p`
    color: #828386;
`;

export const MyProfile = ({ name }) => {
    const { setUser } = useContext(UserContext);
    const handleExit = () => {
        api.post('Auth/logout')
            .then(() => {
                setUser({})
                localStorage.setItem('PROFILE_DATA_SISCOPE', "{}")
            })
    }

    return (
        <>
            <div>
                <GreyParagraph className="ml-3 mt-2">Olá</GreyParagraph>
                <GreyParagraph className="ml-3">
                    <b>{name}</b>
                </GreyParagraph>
                <hr style={{border: "1px solid #F1F1F1"}} />
                <div>
                    <span>
                        <BlueParaprah className="ml-3">
                            <ProfileIcon />
                            Meu perfil
                        </BlueParaprah>
                    </span>
                </div>
                <div>
                    <span>
                        <Link to="/login" onClick={handleExit}>
                            <BlueParaprah className="ml-3">
                                <ExitIcon />
                                Sair
                            </BlueParaprah>
                        </Link>
                    </span>
                </div>
            </div>
        </>
    )
}
